import { PageHeader } from "@/components/common/page-header";
import { FirmContextBanner } from "@/features/clients/components/firm-context-banner";
import { useFirmContext } from "@/features/clients/hooks/use-firm-context";
import { NewArrivalsQueue } from "@/features/new-arrivals/components/new-arrivals-queue";

/** New Arrival queue page: clients moving through the onboarding-approval
 * pipeline, with per-client stage management. */
export default function NewArrivalsPage() {
  const { actingFirmId, actingFirmName } = useFirmContext();
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="New Arrival"
        subtitle="Drive clients through the onboarding-approval pipeline — request docs, submit for approval, and assign the team."
      />
      {actingFirmId && <FirmContextBanner firmName={actingFirmName} />}
      <NewArrivalsQueue />
    </div>
  );
}
